import { PageHeader } from "@/components/common/PageHeader";
import { Box, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import {
  claimantColumns,
  clientColumns,
  policyColumns,
  recordTypes,
  reimbursementColumns,
  stoplossColumns,
  taskColumns,
} from "./recordTypes";
import { Datagrid, DateField, List, NumberField, TextField } from "react-admin";
import { RecordOwnershipAside } from "./components/RecordOwnershipAside";
import { RecordOwnershipBulkActions } from "./components/RecordOwnershipBulkActions";
import { ResourceName } from "@/types";

const RecordOwnership = () => {
  const [resourceSelection, setResourceSelection] = useState<ResourceName>(ResourceName.POLICIES);
  const [columnDetails, setColumnDetails] = useState(policyColumns);

  useEffect(() => {
    if (resourceSelection === ResourceName.POLICIES) {
      setColumnDetails(policyColumns);
    }
    if (resourceSelection === ResourceName.CLIENTS) {
      setColumnDetails(clientColumns);
    }
    if (resourceSelection === ResourceName.TASKS) {
      setColumnDetails(taskColumns);
    }
    if (resourceSelection === ResourceName.STOPLOSS_CLAIMS) {
      setColumnDetails(stoplossColumns);
    }
    if (resourceSelection === ResourceName.CLAIMANTS) {
      setColumnDetails(claimantColumns);
    }
    if (resourceSelection === ResourceName.REIMBURSEMENTS) {
      setColumnDetails(reimbursementColumns);
    }
  }, [resourceSelection]);

  return (
    <Box>
      <PageHeader customTitle="Management" customSectionTitle="Global Record" />
      <Box sx={{ display: "flex", m: "1rem", gap: "1rem" }}>
        <Box>
          <InputLabel id="resource-selection">Resource</InputLabel>
          <Select
            labelId="resource-selection"
            id="resource-selection"
            value={resourceSelection}
            label="Resource"
            onChange={(event) => setResourceSelection(event.target.value as ResourceName)}
            sx={{ width: 240 }}
          >
            {recordTypes.map((record) => (
              <MenuItem value={record.id}>{record.name}</MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
      <Box sx={{ m: "1rem" }}>
        <List
          // Empty Toolbar to remove default buttons
          actions={false}
          resource={resourceSelection}
          aside={<RecordOwnershipAside source={resourceSelection} />}
        >
          <Datagrid bulkActionButtons={<RecordOwnershipBulkActions />}>
            <NumberField source="id" label="ID" />
            {columnDetails.map((column, idx) => (
              <TextField key={idx} source={column.source} label={column.label} />
            ))}
            <DateField source="created_datetime" label="Creation Date" />
          </Datagrid>
        </List>
      </Box>
    </Box>
  );
};

export default RecordOwnership;
